export {default as MeteoWidget} from "./MeteoWidget";